import React from "react";
import { Box } from "@mui/material";
import AnalysisGroup from "./shared/AnalysisGroup";
import { StickyTopRowStack } from "../../../components/commonComponents/StyledComponents/styled";

const TotalPerformanceFilters = () => {
  return (
    <StickyTopRowStack direction={"row"} spacing={4} sx={{ marginRight: "20px" }}>
      <Box sx={{ width: 220 }}>
        <AnalysisGroup reduxKeywordToSaveValue={"embedded_performance_filter"} redux_param_name={"total_performance_analysis_group"} multiSelect={true} />
      </Box>
    </StickyTopRowStack>
  );
};

export default TotalPerformanceFilters;
